import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigation } from '../data/siteData';

const mobileNavigationLabels = {
  TOP: 'トップ',
  ABOUT: 'RYUについて',
  BUSINESS: '事業内容',
  PRODUCTS: '取扱商品',
  COMPANY: '会社情報',
};

const AppHeader = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const headerRef = useRef(null);
  const toggleRef = useRef(null);
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    document.body.classList.toggle('menu-open', menuOpen);
    return () => document.body.classList.remove('menu-open');
  }, [menuOpen]);

  useEffect(() => {
    if (!menuOpen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setMenuOpen(false);
        toggleRef.current?.focus();
      }
      if (event.key === 'Tab') {
        const items = [...headerRef.current.querySelectorAll('a, button')].filter((item) => item.offsetParent !== null);
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    };
    const onResize = () => {
      if (window.innerWidth > 1000) setMenuOpen(false);
    };

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('resize', onResize);
    };
  }, [menuOpen]);

  const solid = scrolled || !isHome || menuOpen;

  return (
    <header ref={headerRef} className={`site-header${solid ? ' is-solid' : ''}`}>
      <div className="site-header__inner">
        <Link className="wordmark" to="/" aria-label="RYU株式会社 トップページ" onClick={() => setMenuOpen(false)}>
          <span className="wordmark__mark" aria-hidden="true">
            <img src="/logo.png" alt="" />
          </span>
          <span className="wordmark__type">
            <strong>RYU</strong>
            <small>CORPORATION</small>
          </span>
        </Link>

        <nav className="site-nav" aria-label="メインナビゲーション">
          {navigation.map((item) => (
            <Link key={item.label} to={item.to}>
              {item.label}
            </Link>
          ))}
        </nav>

        <Link className="site-header__contact" to="/contact">
          CONTACT
          <span aria-hidden="true">↗</span>
        </Link>

        <button
          ref={toggleRef}
          className={`menu-toggle${menuOpen ? ' is-open' : ''}`}
          type="button"
          aria-expanded={menuOpen}
          aria-controls="mobile-navigation"
          aria-label={menuOpen ? 'メニューを閉じる' : 'メニューを開く'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
        </button>
      </div>

      <div
        id="mobile-navigation"
        className={`mobile-nav${menuOpen ? ' is-open' : ''}`}
        aria-hidden={!menuOpen}
        inert={!menuOpen}
        onClick={(event) => { if (event.target.closest('a')) setMenuOpen(false); }}
      >
        <nav aria-label="モバイルナビゲーション">
          {navigation.map((item, index) => (
            <Link key={item.label} to={item.to}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <strong>{item.label}</strong>
              <small>{mobileNavigationLabels[item.label]}</small>
            </Link>
          ))}
          <Link to="/contact">
            <span>06</span>
            <strong>CONTACT</strong>
            <small>お問い合わせ</small>
          </Link>
        </nav>
        <div className="mobile-nav__utility" aria-label="サポート情報">
          <Link to="/faqplus">
            偽物ウイスキーの見分け方
            <span aria-hidden="true">↗</span>
          </Link>
          <Link to="/faq">
            よくあるご質問
            <span aria-hidden="true">↗</span>
          </Link>
        </div>
        <p>LIQUOR WHOLESALE / EC / DISTRIBUTION</p>
      </div>
    </header>
  );
};

export default AppHeader;
